export default "__VITE_ASSET__e3FJByPCCgv8fip_DM$mWQ__";